// clearTopVideoPopupNotifications.js
'use strict';
import { REMOVE_LIST_ITEMS, REMOVE_NOTIFICATIONS } from '../ActionTypes.js';

import getListData from '../selector/getListData.js';

import processTopVideoPopupNotificationQueue from '../action/processTopVideoPopupNotificationQueue.js';

/**
 * Clear flix detail notifications
 * @kind action
 * @return {Promise} Action promise.
 */
const clearTopVideoPopupNotifications = () => async (dispatch, getState) => {
  const notificationIds =
    getListData(getState(), ['popupNotification', 'topVideo'], 'itemIds') || [];
  dispatch({
    type: REMOVE_LIST_ITEMS,
    payload: {
      selectPath: ['popupNotification', 'topVideo'],
      itemIds: notificationIds,
    },
  });
  dispatch({
    type: REMOVE_NOTIFICATIONS,
    payload: {
      itemIds: notificationIds,
    },
  });
  return dispatch(processTopVideoPopupNotificationQueue());
};

export default clearTopVideoPopupNotifications;
